<template>
  <div>
    <Pane :bottom="0" :showRemarks="false">
      <a-tabs
        v-if="showMenu"
        :tabBarStyle="{
                    margin: '0',
                  }"
        v-model="active"
      >
        <a-tab-pane v-if="$getPermission($route.path + '/boss')" key="all" tab="全院当年确认项目"></a-tab-pane>
        <a-tab-pane key="dept" tab="部门全部项目"></a-tab-pane>
      </a-tabs>

      <template v-slot:extra>
        <a-space style="margin-top: 12px; margin-right: -16px" v-if="showMenu">
          <a-button
            v-if="$getPermission($route.path + '/plan/month')"
            @click="$router.push($route.path + '/plan/month')"
            type="default"
          >填报月计划</a-button>
          <a-button
            v-if="$getPermission($route.path + '/plan/year')"
            @click="$router.push($route.path + '/plan/year')"
            type="default"
          >填报年计划</a-button>
          <a-badge :count="count" v-if="$getPermission($route.path + '/plan')">
            <a-button @click="$router.push($route.path + '/plan')" type="primary">计划管理</a-button>
          </a-badge>
          <a-button
            v-if="hasContractManagerRole"
            @click="$refs.fileInput.click()"
            type="default"
          >补充项目信息</a-button>
        </a-space>
        <input
          ref="fileInput"
          type="file"
          accept=".xlsx,.xls"
          style="display:none"
          @change="handleExportWithDeptAndSub"
        />
      </template>
    </Pane>

    <Dept v-show="active === 'dept'" />
    <Boss v-show="active === 'all'" />
  </div>
</template>

<script>
import Dept from "./components/dept.vue";
import Boss from "./components/boss.vue";

import request from "@/api/request";

function fetchData() {
  return request({
    url: "/project-service/projectPlan/count",
    method: "post"
  });
}

export default {
  name: "progress",

  components: {
    Dept,
    Boss
  },

  data() {
    return {
      showMenu: true,
      active: "",
      count: 0
    };
  },

  computed: {
    hasContractManagerRole() {
      const userRoles = this.$store.state.auth?.user?.roles || [];
      if (Array.isArray(userRoles)) {
        return userRoles.some(
          item => item.code === "product_contractManager" || item.code === "admin"
        );
      }
      return false;
    }
  },

  activated() {
    const { from } = this.$route.query;
    if(from == 'dataBoard'){
      this.showMenu = false
    }
    if (this.$getPermission(this.$route.path + "/boss")) {
      this.active = "all";
    } else {
      this.active = "dept";
    }

    if (this.$getPermission(this.$route.path + "/plan")) {
      this.getData();
    }
  },

  methods: {
    getData() {
      fetchData().then(res => {
        console.log("count", res);
        if (typeof res === "number") {
          this.count = res;
        }
      });
    },

    handleExportWithDeptAndSub(event) {
      const file = event.target.files[0];
      if (!file) return;

      const hide = this.$message.loading('处理中...', 0);
      const formData = new FormData();
      formData.append('file', file);

      const baseURL = process.env.NODE_ENV === 'production' ? '/api' : '';
      fetch(`${baseURL}/project-service/contract/projectList/exportWithDeptAndSub`, {
        method: 'POST',
        headers: {
          token: window.localStorage.getItem('token')
        },
        body: formData
      })
        .then(async res => {
          if (!res.ok) {
            const errorText = await res.text().catch(() => '');
            throw new Error(errorText || `HTTP ${res.status}`);
          }
          return res.blob();
        })
        .then(blob => {
          hide();
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = '项目清单导出.xlsx';
          link.click();
          URL.revokeObjectURL(link.href);
          this.$message.success('导出成功');
        })
        .catch(err => {
          hide();
          this.$message.error(err.message || '导出失败');
        })
        .finally(() => {
          event.target.value = '';
        });
    }
  }
};
</script>